import apiClient from "./baseService";

export default {
	getSystemStatus() {
		return apiClient.get('/servicestatus')
	}
}